var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tfa-status" },
    [
      _c("el-switch", {
        attrs: {
          size: "small",
          "active-text": "ON",
          "inactive-text": "OFF",
          disabled: "",
        },
        model: {
          value: _vm.isOn,
          callback: function ($$v) {
            _vm.isOn = $$v
          },
          expression: "isOn",
        },
      }),
      _vm._v(" "),
      _vm.showPhone
        ? _c(
            "span",
            { staticClass: "tfa-phone disable-html-component" },
            [
              _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                _c("span", { staticStyle: { "font-size": "smaller" } }, [
                  _vm._v("2SV Phone"),
                ]),
              ]),
              _vm._v(" "),
              _c("small", [_vm._v(" " + _vm._s(_vm.phone))]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }